<div class="p-0 m-0" style="display: flex; align-items: center;position: relative;" >
    <input  
    name="searchDisignation" autocomplete="off" placeholder="Search ..."
    style="outline: none; border: none; border-bottom: 1px solid #9E9E9E;border-radius: 0;width: 100%;"
    [(ngModel)]="qry" (input)="onTextInput()" (focus)="onFocusInputBox()" 
    (keydown)="onInputBoxKeyDown($event)"
    >
    <ul class="wl-full" *ngIf="showDropDown" class="dropdown-list">
      <li *ngFor="let item of list; let i=index" (click)="selectItem(item,true)" [class.select]="i==_selectItemIdx">
        {{ item[this.params.searchFieldName] }}
      </li>
    </ul>
</div>